import { ErrorHandler } from '@angular/core';
import { environment } from '../environments/environment';
import Bugsnag from '@bugsnag/js';

Bugsnag.start({
  apiKey: environment.bugsnag.apiKey,
  appVersion: environment.version,
});

const bugsnagPlugin = Bugsnag.getPlugin('angular');
export const errorHandlerFactory = () => {
  if (!bugsnagPlugin) {
    console.warn('Bugsnag Angular plugin is not available!');
    return new ErrorHandler();
  }
  return bugsnagPlugin.createErrorHandler();
};
